'use client';

import {
  AccordionContent,
  AccordionHeader,
  AccordionHeaderContent,
  AccordionItem,
  AccordionRoot,
  AccordionTitleText,
  AccordionTrigger,
} from './FooterMobileAccordion.style';
import { MidwestColors } from '@thrivent/midwest-shared';
import { useState } from 'react';
import { useTheme } from 'styled-components';

type Props = {
  title: string;
  children?: React.ReactNode;
};
export const FooterMobileAccordion = ({ title, children }: Props) => {
  const [open, setOpen] = useState(false);
  const { midwestColors }: { midwestColors: MidwestColors } = useTheme();

  const chevronSvg = () => {
    return (
      <svg
        width="24px"
        height="24px"
        viewBox="0 0 12 12"
        focusable="false"
        aria-hidden
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill={
            midwestColors.componentButtonColorBackgroundStrongDestructiveDefault
          }
          d="M8.3 8 6 5.7 3.7 8 3 7.3l3-3 3 3-.7.7z"
        />
      </svg>
    );
  };

  return (
    <AccordionRoot
      type="single"
      collapsible
      defaultValue={open ? 'open' : undefined}
      onChange={() => setOpen((prev) => !prev)}
    >
      <AccordionItem value={title}>
        <AccordionHeader>
          <AccordionTrigger>
            <AccordionHeaderContent>
              <AccordionTitleText>{title}</AccordionTitleText>
              <div>{chevronSvg()}</div>
            </AccordionHeaderContent>
          </AccordionTrigger>
        </AccordionHeader>
        <AccordionContent>{children}</AccordionContent>
      </AccordionItem>
    </AccordionRoot>
  );
};
